<script lang="ts">
import { SettingsService } from '@/services/settings'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SectionGuard',
  props: {
    section: {
      type: String,
      required: true,
    },
  },
  computed: {
    isEnabled() {
      return SettingsService.isSectionEnabled(this.section)
    },
  },
})
</script>

<template>
  <template v-if="isEnabled">
    <slot />
  </template>
  <template v-else>
    <slot name="fallback" />
  </template>
</template>
